export default {
    ADJUDICADO: 'Adjudicado',
    AGUARDANDO_ANALISE: 'Aguardando Análise',
    CLASSIFICADO: 'Classificado',
    ANULADO: 'Anulado',
    CANCELADO: 'Cancelado',
    DESERTO: 'Deserto',
    EM_ANDAMENTO: 'Em Andamento',
    EM_ELABORACAO: 'Em Elaboração',
    FRACASSADO: 'Fracassado',
    REVOGADO: 'Revogado'
}